<div class="histogramContainer">
    <div class="histogramContent">
        <div class="histogramHeader">
            <h4 class="mainDarkBlueText normalFontWeight">
                {{ "RESPONSE_TIME_DISTRIBUTION" | translate }}
            </h4>
            <statistics-png-download-btn [widget]="this" />
        </div>

        <div class="histogramChartContainer">
            <canvas #chartCanvas height="240"></canvas>
        </div>
    </div>
</div>
